export default "__VITE_ASSET__ee324195__"